(yalwa.header_menu = function(pub) {
	"use strict";
	
	pub = pub || {};
	
	pub.init = function() {
		let $all_cat = jQuery('.js-all_categories');
		$all_cat.on('click', () => {
			toggle_mobile_header_menu();
		});
		$all_cat.on('keydown', function(event) {
			if (yalwa.basics.is_space_bar_or_enter_pressed(event)) {
				jQuery('.js-all_categories').trigger('click');
				jQuery('[data-d1="top_navigation_expanded"]').first().focus();
			}
		});
		
		/*let $first_subnav = jQuery('.js-header_menu').find('.listtitle:first > a').first();
		$first_subnav.on('keydown', function(event) {
			if (event.shiftKey && event.key === 'Tab') {
				//shift was down when tab was pressed
				$all_cat.focus();
			}
		});*/
		
		jQuery('.js-header_menu').on('click', (e) => {
			if (e.target.classList.contains('header_menu')) {
				toggle_mobile_header_menu();
			}
		});
	};
	
	function toggle_mobile_header_menu() {
		jQuery('.js-all_categories, .js-header_menu').toggleClass('active');
		if (jQuery('.js-all_categories').hasClass('active')) {
			yalwa.basics.bem_modifier(jQuery('body'), 'gs_showing', 'add');
		} else {
			jQuery('.js-main_col').css('overflow-y','');
			yalwa.basics.bem_modifier(jQuery('body'), 'gs_showing', 'remove');
		}
	}
	
	return pub;
}(yalwa));

yalwa.header_menu.init();